var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3054 12.8958L17.7043 16.2848C17.8935 16.4725 18 16.728 18 16.9945C18 17.2611 17.8935 17.5166 17.7043 17.7043C17.5166 17.8936 17.2611 18 16.9945 18C16.728 18 16.4725 17.8936 16.2848 17.7043L12.8958 14.3054C11.4988 15.402 9.77351 15.9971 7.99742 15.9948C3.58057 15.9948 0 12.4143 0 7.99742C0 3.58057 3.58057 0 7.99742 0C12.4143 0 15.9948 3.58057 15.9948 7.99742C15.9971 9.77351 15.402 11.4988 14.3054 12.8958ZM7.99742 1.99936C4.68478 1.99936 1.99936 4.68478 1.99936 7.99743C1.99936 11.3101 4.68478 13.9955 7.99742 13.9955C11.3101 13.9955 13.9955 11.3101 13.9955 7.99743C13.9955 4.68478 11.3101 1.99936 7.99742 1.99936Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ea23c9bf.svg";
export { ForwardRef as ReactComponent };